import { Modal, Button, Form } from "react-bootstrap";
import { useFGReportsFarmGlobal } from "./ReportsFarmGlobalContext";
import MaterialIcon from 'material-icons-react';
import styles from './ReportsFarmGlobal.module.scss';
import Tabela from "../../Misc/Tabela/Tabela";
import { useEffect, useState } from "react";

const ModalReportSuppliersEdit = () => {
  const { showSupplierEditModal, setShowSupplierEditModal, supplierEditModalForm, setSupplierEditModalForm, handleEditSuppliers } = useFGReportsFarmGlobal();

  const handleSetSupplierEditModalForm = (field, value, subIndex = null) => {
    subIndex !== null ? supplierEditModalForm.subSuppliers[subIndex][field] = value : supplierEditModalForm[field] = value;
    setSupplierEditModalForm({ ...supplierEditModalForm });
  }

  return (
    <Modal
      show={showSupplierEditModal}
      onHide={() => setShowSupplierEditModal(false)}
      backdrop={'static'}
      keyboard={false}
      centered
      size={'xl'}
      fullscreen={'xl-down'}
      backdropClassName={styles.backdrop_z_override}
    >
      <Modal.Header closeButton>
        <Modal.Title>Update Supplier</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        <Form style={{ display: 'flex', gap: '20px', padding: '10px 0px' }}>
          <Form.Group style={{ alignSelf: 'center', width: '30%' }}>
            <Form.Control
              type={'text'}
              value={supplierEditModalForm.supplier || ''}
              onChange={e => handleSetSupplierEditModalForm('supplier', e.target.value)}
              placeholder={'Supplier'}
              style={{ width: '100%' }}
              disabled
            >
            </Form.Control>
          </Form.Group>

          <Form.Group style={{ alignSelf: 'center', width: '25%' }}>
            <Form.Check
              type={'switch'}
              defaultChecked={supplierEditModalForm.supplier_active}
              style={{
                fontSize: '20px',
                fontWeight: '700',
                color: supplierEditModalForm.supplier_active ? '#20b746' : '#dc3545'
              }}
              label="Supplier Active?"
              onChange={() => handleSetSupplierEditModalForm('supplier_active', !supplierEditModalForm.supplier_active)}
              value={supplierEditModalForm.supplier_active || false}
            />
            <Form.Check
              type={'switch'}
              defaultChecked={supplierEditModalForm.supplies_pa}
              style={{ fontSize: '20px' }}
              label="Supplies Finished Product (PA)?"
              onChange={() => handleSetSupplierEditModalForm('supplies_pa', !supplierEditModalForm.supplies_pa)}
              value={supplierEditModalForm.supplies_pa || false}
            />
            <Form.Check
              type={'switch'}
              defaultChecked={supplierEditModalForm.supplies_mp}
              style={{ fontSize: '20px' }}
              label="Supplies Raw Material (MP)?"
              onChange={() => handleSetSupplierEditModalForm('supplies_mp', !supplierEditModalForm.supplies_mp)}
              value={supplierEditModalForm.supplies_mp || false}
            />
          </Form.Group>

          <div className={styles.vertical_separator} />

          <Form.Group style={{ alignSelf: 'center', display: 'flex', flexDirection: 'column', gap: '6px', width: '40%' }}>
            {supplierEditModalForm.subSuppliers.map((item, index) => {
              return (
                <div key={`subsupplier_edit_${index}`} style={{ display: 'flex', gap: '6px' }}>
                  <Form.Control
                    type={'text'}
                    value={item.subSupplier || ''}
                    onChange={e => handleSetSupplierEditModalForm('subSupplier', e.target.value, index)}
                    placeholder={`Sub-Supplier ${index + 1}`}
                    style={{ width: '60%' }}
                    disabled={item.inserted}
                    isInvalid={
                      supplierEditModalForm.subSuppliers.some((sub, subIndex) =>
                        index !== subIndex &&
                        sub.subSupplier?.trim().toLowerCase() === item.subSupplier?.trim().toLowerCase()
                      )
                    }
                  />
                  {
                    item.inserted &&
                    <Form.Group style={{ alignSelf: 'center', width: '40%' }}>
                      <Form.Check
                        type={'switch'}
                        defaultChecked={item.subSupplier_active}
                        style={{ fontSize: '20px' }}
                        label={"Active?"}
                        onChange={() => handleSetSupplierEditModalForm('subSupplier_active', !item.subSupplier_active, index)}
                        value={item.subSupplier_active}
                      />
                    </Form.Group>
                  }
                  {
                    !item.inserted &&
                    <label
                      className={styles.input_btn_delete}
                      onClick={() => {
                        const updatedForm = { ...supplierEditModalForm };
                        updatedForm.subSuppliers.splice(index, 1);
                        setSupplierEditModalForm({ ...updatedForm });
                      }}
                    >
                      <MaterialIcon icon="delete" size={20} color={'#DC3545'} />
                    </label>
                  }
                </div>
              );
            })}
            <i
              className={styles.input_btn}
              style={{ marginRight: 'auto' }}
              onClick={() => {
                const updatedForm = { ...supplierEditModalForm };
                supplierEditModalForm.subSuppliers.push({
                  id_subSupplier: null,
                  inserted: false,
                  subSupplier: '',
                  subSupplier_active: 1
                });
                setSupplierEditModalForm({ ...updatedForm });
              }
              }
            >
              <MaterialIcon icon="add_circle" size={20} color={'#007bff'} />
              &nbsp;Add Sub-Supplier
            </i>
          </Form.Group>

          {/* <label
            className={styles.input_btn_delete}
            style={{ justifySelf: 'flex-end', marginLeft: 'auto' }}
            onClick={() => {
              const updatedForm = [...supplierEditModalForm];
              updatedForm.splice(index, 1);
              setSupplierEditModalForm([...updatedForm]);
            }}
          >
            <MaterialIcon icon="delete" size={20} color={'#DC3545'} />
          </label> */}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant={'success'}
          style={{ width: '200px' }}
          onClick={handleEditSuppliers}
        >
          Update This Supplier
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalReportSuppliersEdit;
